<template lang="pug">
.homer-wrapper
  .left
    SearchAndFilter(@searchResults="(searchResults)=>updateSearchResults(searchResults)"
                    @jumpToDate="(newDate)=>jumpToDate(newDate)"
                    @selectDateRange="(range)=>selectDateRange(range)")
  .right
    Calendar(:searchResults="filteredSearchResults" :newDate="newDate" :newDateRange="newDateRange")
</template>

<script>
import {DateTime} from 'luxon';
import SearchAndFilter from "@/components/molecules/SearchAndFilter.vue";
import Calendar from "@/components/molecules/Calendar.vue";
export default {
  data() {
    return {
      objectNameSearchString: "",
      objectRoomsSearchString: null,
      objectPersonsSearchString: null,
      searchResults: null,
      newDate: new Date(),
      newDateRange: null
    };
  },
  components: { SearchAndFilter, Calendar },
  computed: {
    filteredSearchResults() {
      if (!this.searchResults) return [];
      let r = this.searchResults.filter(s => {
        return (`${s.code.toLowerCase()} ${s.name.toLowerCase()}`).includes(this.objectNameSearchString.toLowerCase())
      });

      if (this.objectRoomsSearchString !== null) {
        r = r.filter(s => {
          return s.rooms === this.objectRoomsSearchString
        }); 
      }

      if (this.objectPersonsSearchString !== null) {
        r = r.filter(s => {
          return s.persons >= this.objectPersonsSearchString
        }); 
      }
      return r;
    }
  },
  mounted() {
    // Here are just some event listeners
    const self = this;
    this.$root.$on('objectNameSearchString', (e) => {
      self.objectNameSearchString = e;
    });
    this.$root.$on('objectRoomsSearchString', (e) => {
      self.objectRoomsSearchString = e;
    });
    this.$root.$on('objectPersonsSearchString', (e) => {
      self.objectPersonsSearchString = e;
    });
  },
  methods: {
    updateSearchResults(searchResults) {
      this.searchResults = searchResults;
    },
    jumpToDate(newDate) {
      this.newDate = newDate;
    },
    selectDateRange(range) {
      const copyRange = {...range};
      copyRange.startDate = DateTime.fromJSDate(copyRange.startDate).set({hour: 15}).minus({days: -1}).toJSDate();
      copyRange.endDate = DateTime.fromJSDate(copyRange.endDate).set({hour: 10}).minus({days: 0}).toJSDate();
      this.newDateRange = copyRange;
    }
  }
};
</script>

<style lang="scss" scoped>
.homer-wrapper {
  box-sizing: border-box;
  display: grid;
  grid-template-areas: "top" "bottom";
  grid-template-rows: 180px auto;
  overflow: hidden;
  height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);

  .left {
    grid-area: top;
    height: 100%;
    width: 100%;
  }
  .left > div {
    height: 100%;
    width: 100%;
  }
  .right {
    grid-area: bottom;
    height: 100%;
    width: 100%;
  }
}
</style>
